import Cookies from "js-cookie";
import {
  GET_COURSES_URL_INSTITUTION,
  GET_SINGLE_COURSE_URL_INSTITUTION,
  GET_SUBJECTS_URL_INSTITUTION,
  GET_TOPICS_URL_INSTITUTION,
  GET_SUBTOPIC_URL_INSTITUTION,
} from "../../apiurls/apiurls";

const getInstitutionToken = () => {
  return Cookies.get("institution_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getInstitutionToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getCoursesInstitution = async () => {
  try {
    const response = await fetch(GET_COURSES_URL_INSTITUTION, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    
    if (Array.isArray(responseData) && responseData.length > 0 && Array.isArray(responseData[0].course)) {
      return responseData[0].course;
    }
    
    if (Array.isArray(responseData)) {
      return responseData;
    }
    
    return [];
  } catch (error) {
    console.error("Error fetching institution courses:", error);
    throw error;
  }
};

export const getSingleCourseInstitution = async (courseKey) => {
  try {
    const params = new URLSearchParams({ key: courseKey });
    const response = await fetch(
      `${GET_SINGLE_COURSE_URL_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching institution course:", error);
    throw error;
  }
};

export const getSubjectsInstitution = async (courseKey) => {
  try {
    const params = new URLSearchParams({ course_key: courseKey });
    const response = await fetch(
      `${GET_SUBJECTS_URL_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching institution subjects:", error);
    throw error;
  }
};

export const getTopicsInstitution = async (subjectKey) => {
  try {
    const params = new URLSearchParams({ subject_key: subjectKey });
    const response = await fetch(
      `${GET_TOPICS_URL_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching institution topics:", error);
    throw error;
  }
};

export const getSubtopicsInstitution = async (topicKey) => {
  try {
    const params = new URLSearchParams({ topic_key: topicKey });
    const response = await fetch(
      `${GET_SUBTOPIC_URL_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching institution subtopics:", error);
    throw error;
  }
};